import { AnnouncementBanner } from '@medeloop/medeloop-components-library';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const PlatformNotification = () => {
  const { platformNotificationAccount } = useFlags();

  if (!platformNotificationAccount?.enabled) return null;

  return <AnnouncementBanner {...platformNotificationAccount} />;
};
